import React from "react";
import {
  makeStyles,
  Typography,
  Input,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItemText,
  ListItem,
  DialogActions,
} from "@material-ui/core";

import { RemoveCircleOutlined } from "@material-ui/icons";
import { Field, FieldArray } from "formik";
import AddIcon from "@material-ui/icons/AddCircle";
import FMUInputField from "./shared/FormIkMUFormComponent/FMUInputField";
import { getLogo } from "./shared/helpers/helper";
import { tokens } from "../theme/tokens";
const useStyles = makeStyles(
  (theme, data, index, handleSetIndex, setFieldValue) => ({
    dialogContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      rowGap: "20px",
      width: "70%",
      margin: "auto",
      paddingBottom: "20px",
      textAlign: "center",
    },
    dialogHeading: {
      color: "#585858",
      fontSize: "1em",
      fontFamily: tokens.type.family,
      fontWeight: 500,
      textAlign: "center",
    },
    dialogItem: {
      display: "flex",
      columnGap: "25px",
      alignItems: "center",
    },
    dialogDiv: {
      width: "600px",
      height: "320px",
    },
    input: {
      // width: "95%",
      border: `1px solid ${tokens.color.border.default}`,
      borderRadius: "10px",
      height: "40px",
      paddingLeft: "3px",
      "& .MuiInputBase-input": {
        textIndent: "10px",
      },
      backgroundColor: tokens.color.surface.sunken,
    },
    postButton: {
      height: "35px",
      fontSize: ".9em",
      width: "150px",
      color: "white",
      backgroundColor: "rgb(0, 151, 187)",
      fontWeight: "600",
      textTransform: "capitalize",
      border: `1px solid ${tokens.color.brand.primary}`,
      borderRadius: "25px",

      "&:hover": {
        backgroundColor: tokens.color.brand.primary,
        opacity: "0.8",
      },
    },
  }),
);
function FieldsDialog({
  dialogOpen,
  handleDialogClose,
  data,
  arrayName,
  title,
}) {
  const classes = useStyles();
  return (
    <Dialog open={dialogOpen} maxWidth={"lg"} onClose={handleDialogClose}>
      <FieldArray name={arrayName}>
        {({ push, remove }) => (
          <>
            <DialogTitle>
              <h2 className={classes.dialogHeading}>{title}</h2>
            </DialogTitle>
            <DialogContent
              className={classes.dialogDiv}
              style={
                data.length > 5
                  ? { overflowY: "auto" }
                  : { overflowY: "hidden" }
              }
            >
              <div className={classes.dialogContainer}>
                {data?.map((val, key) => {
                  return (
                    <div
                      className={classes.dialogItem}
                      style={{ position: "relative" }}
                    >
                      <Field
                        name={`${arrayName}[${key}]`}
                        fullwidth={true}
                        disableUnderline={true}
                        className={classes.input}
                        component={FMUInputField}
                      />
                      {key === 0 ? (
                        <AddIcon
                          style={{
                            position: "absolute",
                            right: -40,
                            color: tokens.color.brand.primaryAction,
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            push("");
                          }}
                        />
                      ) : (
                        <RemoveCircleOutlined
                          style={{
                            position: "absolute",
                            right: -40,
                            color: tokens.color.brand.primaryAction,
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            remove(key);
                          }}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </DialogContent>
            <DialogActions style={{ paddingBottom: "14px" }}>
              <Button
                className={classes.postButton}
                onClick={handleDialogClose}
                style={{ marginLeft: "auto", marginRight: "auto" }}
              >
                Update
              </Button>
            </DialogActions>
          </>
        )}
      </FieldArray>
    </Dialog>
  );
}

export default FieldsDialog;
